import React from "react";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../Breadcrumb";
export default () => {
    const location = useLocation();
    return (React.createElement(Breadcrumb, { customerName: location.state?.customerName ?? "Deal detail" }));
};
